import React from 'react';
import '../../../VendorStyles/VendorRegistrationBG.css';
import VendorRegistrationSideMenuBar from './VendorRegistrationSideMenuBar';
import VendorRegistrationTopMenuBar from './VendorRegistrationTopMenuBar';
import VendorRegistrationForm from './VendorRegistrationForm';

function VendorRegistrationBG() {
    
    return (
        <div>

            <VendorRegistrationTopMenuBar></VendorRegistrationTopMenuBar>
            <VendorRegistrationSideMenuBar></VendorRegistrationSideMenuBar>
            <VendorRegistrationForm></VendorRegistrationForm>

        </div>
    );
}

export default VendorRegistrationBG;